import React, { Component } from 'react';
import asyncWrapper from '../../../../../../shared/javascripts/hocs/asyncWrapper'
import Loading from '../../../../../../shared/javascripts/components/Loading'
import { Chart } from "react-google-charts";

import UserProgressApi from '../../../api/UserProgressApi'

class OverallScore extends Component {
  constructor(props) {
    super(props)
    this.state = {data: []}
  }

  componentDidMount() {
    UserProgressApi.fetchOverallScore(this.props.user.id)
      .then(this.props.handleErrors)
      .then(response => {
        this.setState({data: response},
          ()=>this.props.setLoading()
        )
      }).catch(error => console.log(error))
  }

  render() {
    if(this.props.loading) {return <Loading />}

    return (
      <Chart
        chartType="ComboChart"
        width={'100%'}
        data={this.state.data}
        options={{
            title: 'Overall Score',
            chartArea: { width: '60%' },
            "vAxis": {
              "title": "Percentage(%)",
              minValue: 0,
              maxValue: 100,
              viewWindow: {
                min: 0,
                max: 100
              }
            },
            "hAxis": {"title": "Rate"},
            "seriesType": "bars"
          }}
      />
    )
  }
}

export default asyncWrapper(OverallScore)



// WEBPACK FOOTER //
// ./src/reports/google_play/javascripts/components/User/Scores/OverallScore.jsx